module.exports = __webpack_public_path__ + "static/media/mnbaq-original-logo.34d60b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mnbaq-original-logo.png
// module id = 812
// module chunks = 1